import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.function.name.js";
import React, { Fragment } from 'react';
import { CONTEXT } from './constants';
/*
 * A Higher-Order Component that is used to wrap a Component to augment it with a script tag
 * containing JSON-LD schema.
 *
 * @param {Object|function} mapping An object or a function returning an object that represents
 *                                  your JSON-LD schema.
 */

var withJsonLd = function withJsonLd(mapping) {
  return function (WrappedComponent) {
    var WithJsonLd = function WithJsonLd(props) {
      var mappedJsonLd = typeof mapping === 'function' ? mapping(props) : mapping;

      if (!mappedJsonLd || _isEmpty(mappedJsonLd)) {
        return /*#__PURE__*/React.createElement(WrappedComponent, props);
      }

      var jsonLd = _objectSpread(_objectSpread({}, CONTEXT), mappedJsonLd);

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(WrappedComponent, props), /*#__PURE__*/React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(jsonLd)
        }
      }));
    };

    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithJsonLd.displayName = "WithJsonLd(".concat(displayName, ")");
    return WithJsonLd;
  };
};

export default withJsonLd;